import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import VConsole from 'vconsole'
import '@/utils/index'
import browserCheck from '@/utils/checkBrowser'

if (browserCheck.isWechat && browserCheck.isIphone) {
  window._iosShareUrl = location.href
}

if (process.env.VUE_APP_ENV !== 'prod' && process.env.VUE_APP_ENV !== 'local') {
  new VConsole()
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
